module.exports = __webpack_public_path__ + "img/zp-img1.bcded6c8.png";